import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetAvailableBulkItemsDocument,
  GetAvailableBulkItemsQueryVariables,
} from '../../types/api/graphql';

const useAvailableBulkMessageItems = (
  variables: GetAvailableBulkItemsQueryVariables
) => {
  const {
    data: availableBulkItemsData,
    loading: availableBulkItemsDataLoading,
  } = useQuery(GetAvailableBulkItemsDocument, {
    variables: {
      ...variables,
    },
    skip: !variables.healthProviderId,
    fetchPolicy: 'network-only',
  });
  const data = useMemo(() => {
    if (availableBulkItemsData?.bulkCampaigns) {
      return {
        ...availableBulkItemsData.bulkCampaigns,
        items: availableBulkItemsData.bulkCampaigns.items ?? [],
      };
    }

    return null;
  }, [availableBulkItemsData?.bulkCampaigns]);

  return {
    data,
    loading: availableBulkItemsDataLoading,
  };
};

export { useAvailableBulkMessageItems };
